var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Media / Icons / Arootah / Mission Statement"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M16.0583 3.9C15.868 3.76293 15.6482 3.67263 15.4165 3.63643C15.1848 3.60023 14.9479 3.61916 14.7249 3.69167C14.1367 3.85707 13.5275 3.93568 12.9166 3.925C12.0138 3.87599 11.1285 3.65539 10.3083 3.275C9.29495 2.80636 8.19888 2.54296 7.08327 2.5C4.67493 2.5 3.74993 3.33333 3.58327 3.45C3.50352 3.52816 3.4403 3.62155 3.39735 3.72462C3.35441 3.82769 3.33261 3.93834 3.33327 4.05V16.6667C3.33327 16.8877 3.42106 17.0996 3.57734 17.2559C3.73362 17.4122 3.94559 17.5 4.1666 17.5C4.38761 17.5 4.59957 17.4122 4.75585 17.2559C4.91214 17.0996 4.99993 16.8877 4.99993 16.6667V13.0833C5.66396 12.8291 6.37282 12.7128 7.08327 12.7417C7.98611 12.7907 8.87134 13.0113 9.6916 13.3917C10.7049 13.8603 11.801 14.1237 12.9166 14.1667C13.9212 14.2046 14.9205 14.0047 15.8333 13.5833C16.0793 13.4678 16.2878 13.2854 16.4352 13.057C16.5825 12.8286 16.6627 12.5634 16.6666 12.2917V5.09167C16.6663 4.85915 16.611 4.62999 16.5053 4.42289C16.3996 4.21579 16.2464 4.03662 16.0583 3.9Z",
    fill: "black"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlag);
export default __webpack_public_path__ + "static/media/flag.07fc8aedc68f413a2ddca8895557155e.svg";
export { ForwardRef as ReactComponent };